<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', Helvetica, Arial, sans-serif;
  background-color: #f5f7fa;
}

* {
  box-sizing: border-box;
}

/* 隐藏旧调试代码残留的 temp-err-banner */
#temp-err-banner {
  display: none !important;
}
</style>
